// extracted by mini-css-extract-plugin
export var backupIcon = "_o0-1";
export var image = "_o0-0";